export default __webpack_public_path__ + "static/SupportLargeFont-DONT1-20bef4a91d2b39ad28a583884402975e.png";